'use client'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { PropsWithChildren, ReactElement } from 'react'

const DatePickerProvider = ({ children }: PropsWithChildren): ReactElement => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
)

export default DatePickerProvider
